/**
 * Libellés tickets ouverts caisse (comptoir vs service restaurant).
 * Ne pas préfixer « Table » — le label est saisi librement par le commerçant.
 */

export function formatCaisseTicketShortRef(ticket) {
  const raw = ticket?.numeroTicket || ticket?.numero || ticket?.id || '';
  const s = String(raw).trim();
  if (!s) return '';
  if (s.startsWith('TKT-')) return s;
  if (s.startsWith('CMD-POS-')) {
    const tail = s.slice('CMD-POS-'.length);
    return tail.length > 10 ? tail.slice(-8) : tail;
  }
  if (s.length > 14) return s.slice(-8);
  return s;
}

/** Contexte restaurant issu de GET /caisse/tickets-ouverts (restaurantService). */
export function resolveCaisseOpenTicketRestaurantService(ticket) {
  if (ticket?.restaurantService?.serviceSessionId && ticket?.restaurantService?.tableId) {
    return ticket.restaurantService;
  }
  const session = ticket?.posServiceSession;
  if (!session?.id || !session?.table?.label) return null;
  return {
    serviceSessionId: session.id,
    tableId: session.tableId || session.table?.id,
    tableLabel: session.table.label,
    floorName: session.table.floor?.name ?? null,
    coverCount: session.coverCount ?? null,
    serviceStatus: session.status ?? null,
  };
}

export function formatCaisseOpenTicketTitle(ticket) {
  const rs = resolveCaisseOpenTicketRestaurantService(ticket);
  if (rs?.tableLabel) {
    const label = String(rs.tableLabel).trim();
    const floor = rs.floorName ? String(rs.floorName).trim() : '';
    return floor ? `${label} — ${floor}` : label;
  }
  const shortRef = formatCaisseTicketShortRef(ticket);
  return shortRef ? `Comptoir — Ticket ${shortRef}` : 'Comptoir';
}

export function formatCaisseOpenTicketSecondaryRef(ticket) {
  const full = ticket?.numeroTicket || ticket?.numero;
  if (!full) return null;
  const rs = resolveCaisseOpenTicketRestaurantService(ticket);
  if (rs?.tableLabel) return String(full);
  return null;
}

export function formatCaisseOpenTicketSubtitle(ticket, fmtMoney) {
  const parts = [];
  const articleCount = ticket?.produits?.length || 0;
  parts.push(`${articleCount} article(s)`);
  if (typeof fmtMoney === 'function') {
    parts.push(fmtMoney(ticket?.total || 0));
  }
  const rs = resolveCaisseOpenTicketRestaurantService(ticket);
  if (rs?.coverCount != null && rs.coverCount > 0) {
    parts.push(`${rs.coverCount} couvert(s)`);
  }
  if (ticket?.dejaRegle > 0.01 && typeof fmtMoney === 'function') {
    parts.push(`encaissé ${fmtMoney(ticket.dejaRegle)}`);
  }
  if (ticket?.soldeRestant != null && typeof fmtMoney === 'function') {
    parts.push(`solde ${fmtMoney(ticket.soldeRestant)}`);
  }
  const secondary = formatCaisseOpenTicketSecondaryRef(ticket);
  if (secondary) {
    parts.push(secondary);
  }
  return parts.join(' · ');
}
